/**
 * Mock case data for /calculator-v3 preview.
 *
 * Represents the case shape after a user clicks "Open in calculator"
 * from a /broker/cases entry. In real wiring this is fed by
 * CaseContextService and prefills the F2 form.
 */

export interface MockCase {
  caseId: string;
  caseCode: string;       // user-facing "c-2284"
  clientName: string;
  age: number;
  /** Premium in dollars */
  premium: number;
  /** "qualified" | "nq" — funding source */
  funding: 'qualified' | 'nq' | 'qlac';
  /** Original state from the case, before any override */
  state: string;
  productType: 'IA' | 'FA' | 'RILA' | 'VA';
  ownership: 'single' | 'joint';
  paymentFrequency: 'annual' | 'monthly';
  /** M / F — used by the engine to pick gender-specific factors. */
  gender: 'M' | 'F';
}

export const MOCK_CASE: MockCase = {
  caseId: 'c-2284',
  caseCode: 'c-2284',
  clientName: 'Marcus Howell',
  age: 60,
  premium: 250_000,
  funding: 'qualified',
  state: 'IL',
  productType: 'IA',
  ownership: 'single',
  paymentFrequency: 'annual',
  gender: 'M',
};
